import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ContactService from '../services/contact.service'
import {gaEventWithUserIdLabel, gaPageView, LOG_OUT} from "../constants";
import {UserAction} from "../actions/UserAction";
import AuthService from "../services/auth.service";
import {Button, Input, message, Modal} from "antd";
import i18n from "i18next";
import {EditOutlined} from "@ant-design/icons";

const {TextArea} = Input

class Contact extends Component {

    constructor(props) {
        super(props)
        this.state = {
            buttonLoading: false,
            contactName: "",
            contactEmail: "",
            contactMessage: ""
        }
    }

    componentDidMount() {
        gaPageView()
    }

    sendMessage = () => {

        let subject = this.state.subject
        let contactMessage = this.state.contactMessage

        if (!subject || subject.trim() === "") {
            return message.error(i18n.t('error_subject'))
        }
        if (!contactMessage || contactMessage.trim() === "") {
            return message.error(i18n.t('error_contactMessage'))
        }

        this.setState({buttonLoading: true})

        ContactService.send(subject, contactMessage)
            .then(
                response => {
                    this.setState({buttonLoading: false})
                    if (response.data.success === true) {
                        Modal.success({
                            centered: true,
                            content: i18n.t('email_sent'),
                            onOk() {
                            }
                        })
                    } else {
                        gaEventWithUserIdLabel("ContactService.send Data Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    this.setState({buttonLoading: false})
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("ContactService.send Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    handleInputChange = (e) => {
        const {name, value} = e.target
        this.setState({[name]: value})
    }

    render() {

        let buttonLoading = this.state.buttonLoading

        return (
            <>
                <section className="map-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="col-lg-8 text-center">
                                <div className="section-title">
                                    <h2>{i18n.t('contact_us_title')}</h2>
                                    <p>{i18n.t('contact_us_desc')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mr-0 ml-0 custom-box-shadow">
                            <div className="form-box custom-ant-input-wrapper">
                                <div>
                                    <form method="POST" action="" id="contact-form">
                                        <div>
                                            <Input type="text"
                                                   name="subject"
                                                   placeholder={i18n.t('contact_subject')}
                                                   autoComplete="off"
                                                   prefix={<EditOutlined/>}
                                                   onInput={this.handleInputChange}/>
                                        </div>
                                        <div>
                                            <TextArea
                                                name="contactMessage"
                                                onInput={this.handleInputChange}
                                                // onChange={this.onChange}
                                                placeholder={i18n.t('contact_message')}
                                                autoSize={{minRows: 13, maxRows: 13}}/>
                                        </div>
                                        <div className="form-group mt-20">
                                            <div className="row">
                                                <div className="col-3">
                                                    <Button
                                                        className="custom-button"
                                                        type="button"
                                                        onClick={this.sendMessage}
                                                        loading={buttonLoading}>
                                                        {i18n.t('send')}
                                                    </Button>
                                                </div>
                                                <div className="col-9"/>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);